/**
 * Kendo UI PromptBox Widget
 *
 * This file serves as the entry point for the PromptBox widget.
 */
import "./kendo.core.js";
import "./kendo.textarea.js";
import "./kendo.textbox.js";
import "./kendo.html.button.js";
import { PromptBox } from "./promptbox";
import { inject, WidgetRegistryService } from "./core";

export const __meta__ = {
    id: "promptbox",
    name: "PromptBox",
    category: "web",
    description: "The PromptBox component - a composite input for chat interfaces.",
    depends: ["core", "textarea", "textbox", "html.button"]
};

// Register the widget
inject(WidgetRegistryService).register(PromptBox);

// Re-export for consumers
export { PromptBox };

export default kendo;
